@if (customField) {
  <div [ngClass]="{ 'deactive-field': deactivateField }" [class]="'csw-booking-question csw-'+customField.type+ ' csw-'+customField.type+'-'+customField?.id" role="group" [attr.aria-labelledby]="customField.id + '_label'" [attr.aria-describedby]="customField.id + '_description'" [attr.aria-invalid]="customFieldControl?.touched && customFieldControl?.invalid" [attr.aria-disabled]="!isEditAllowed || deactivateField">
    @switch (customField.type) {
      @case (customFieldConst.CUSTOM_FIELD_SELECT) {
        <div class="mt-3 row custom-select-field" role="region" [attr.aria-label]="customField | translation: 'label': lang">
          <ng-container [ngTemplateOutlet]="labelsTemplate" />
          @for (element of columnRangeArray; track $index; let innerIndex = $index) {
            <div [class]="'border-end no-right-border-last-child border-sm-right-none mt-3 mt-md-0 mt-no-first-child col-md-'+ (12 / columnRangeCount)">
              @if (parentField?.generate_entity_count) {
                <ng-container
                  [ngTemplateOutlet]="entityNameTemplate"
                  [ngTemplateOutletContext]="{
                    $implicit: innerIndex,
                    widgetConf: widgetConf
                  }"
                />
              }
              <ng-select
                #customFieldControl="ngModel"
                [id]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                [name]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                [placeholder]="customField.is_multi_language === 1 ? (customField | translation: 'placeholder': lang) : (customField.placeholder ? customField.placeholder : '')"
                [multiple]="(customField.is_multiple_select === 1)"
                [closeOnSelect]="!(customField.is_multiple_select === 1)"
                [clearable]="!(customField.is_multiple_select === 1)"
                [(ngModel)]="customField.customerSelectedValue[(customEventIndex ? customEventIndex : innerIndex)]"
                (change)="onSelectChange($event, (customEventIndex ? customEventIndex : innerIndex))"
                [readonly]="!isEditAllowed || deactivateField"
                [searchable]="true"
                [required]="customField.required === 1  && customField.is_read_only === 0"
                [ngClass]="{ 'is-invalid': customFieldControl.touched && customFieldControl.invalid }"
                (open)="bindYoutubeInfoUrlClickHandler()"
                (close)="unbindYoutubeInfoUrlClickHandler()"
                role="combobox"
                [attr.aria-label]="customField | translation: 'label': lang"
                [attr.aria-required]="customField.required === 1 && customField.is_read_only === 0"
                [attr.aria-invalid]="customFieldControl.touched && customFieldControl.invalid"
                [attr.aria-describedby]="customField.id + '_error_' + innerIndex"
                [attr.aria-expanded]="false"
                [attr.aria-haspopup]="'listbox'"
                [attr.aria-controls]="customField.id + '_listbox_' + innerIndex"
              >
                @for (custom_field_option of customField.custom_field_options; track custom_field_option) {
                  @if (custom_field_option.id != null) {
                    <ng-option
                      [value]="custom_field_option.id"
                      [disabled]="customField.is_read_only === 1"
                      role="option"
                      [attr.aria-selected]="customField.customerSelectedValue[innerIndex] === custom_field_option.id"
                      [attr.aria-label]="custom_field_option | translation: 'label': lang"
                    >
                      <!-- Option icon -->
                      @if (custom_field_option?.image | isEmptyString) {
                        <img
                          class="option-icon me-2"
                          [src]="custom_field_option?.image"
                          height="25"
                          width="25"
                          [attr.alt]="(custom_field_option | translation: 'label': lang) + ' icon'"
                        />
                      }
                      <!-- Option text -->
                      {{ custom_field_option | translation: 'label': lang }}
                      <!-- Youtube -->
                      @if ((custom_field_option?.youtube_url | isEmptyString)) {
                        <span class="info-urls float-end">
                          <a
                            class="select-option-youtube-element"
                            #selectOptionYoutubeElement
                            [attr.data-option]="(custom_field_option | json)"
                            role="button"
                            [attr.aria-label]="'Watch YouTube video for ' + (custom_field_option | translation: 'label': lang)"
                          >
                            <img
                              class="youtube-icon"
                              [src]="deployUrl + 'assets/images/logo/youtube_social_icon_red.png'"
                              alt="YouTube"
                              aria-hidden="true"
                            />
                          </a>
                        </span>
                      }
                      <!-- Info -->
                      @if ((custom_field_option?.info_url | isEmptyString)) {
                        <span
                          class="info-urls float-end"
                          [ngClass]="{
                            'me-2': (custom_field_option?.youtube_url | isEmptyString)
                          }"
                        >
                          <a
                            target="_blank"
                            [href]="custom_field_option.info_url"
                            role="button"
                            [attr.aria-label]="'More information about ' + (custom_field_option | translation: 'label': lang)"
                          >
                            <img
                              [src]="deployUrl + 'assets/images/icons/info-filled-icon.svg'"
                              alt="Information"
                              aria-hidden="true"
                            />
                          </a>
                        </span>
                      }
                    </ng-option>
                  }
                }
              </ng-select>
              @if (customFieldControl.touched && customFieldControl.invalid) {
                <div
                  class="text-danger"
                  [id]="customField.id + '_error_' + innerIndex"
                  role="alert"
                  aria-live="polite"
                >
                  @if (customFieldControl?.errors?.required) {
                    {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang | calioTranslateResolver: { text: customField | translation: 'label': lang }) }}
                  }
                </div>
              }
            </div>
          }
        </div>
        @if (customField?.showEndOfProcess === true) {
          <ng-container [ngTemplateOutlet]="endOfProcessBlock" />
        }
        @if (customField.generate_entity_count && customField?.showEndOfProcess === false) {
          <ng-container
            [ngTemplateOutlet]="entityNameFieldTemplate"
            [ngTemplateOutletContext]="{
              $implicit: customField.generate_entity_count,
              widgetConf: widgetConf
            }"
          />
        }
      }
      @case (customFieldConst.CUSTOM_FIELD_TEXT) {
        <div class="mt-3 row" role="region" [attr.aria-label]="customField | translation: 'label': lang">
          <ng-container [ngTemplateOutlet]="labelsTemplate" />
          @for (element of columnRangeArray; track $index; let innerIndex = $index) {
            <div [class]="'border-end no-right-border-last-child border-sm-right-none mt-3 mt-md-0 mt-no-first-child col-md-'+ (12 / columnRangeCount)">
              @if (parentField?.generate_entity_count) {
                <ng-container
                  [ngTemplateOutlet]="entityNameTemplate"
                  [ngTemplateOutletContext]="{
                    $implicit: innerIndex,
                    widgetConf: widgetConf
                  }"
                />
              }
              <input
                [id]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                [name]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                type="text"
                class="form-control"
                [placeholder]="(customField.is_multi_language === 1 ?  (customField | translation: 'placeholder': lang) : (customField.placeholder ? customField.placeholder : ''))"
                [(ngModel)]="customField.customerSelectedValue[innerIndex]"
                #customFieldControl="ngModel"
                [disabled]="!isEditAllowed || deactivateField"
                [pattern]="customField.regex"
                phishingProtection
                [required]="customField.required === 1  && customField.is_read_only === 0"
                [minlength]="customField?.min_characters > 0 ? customField.min_characters : null"
                [maxlength]="customField?.max_characters > 0 ? customField.max_characters : null"
                (blur)="onChangeCustomFieldSelectedValue(); onBlurCustomFieldSelectedValue();"
                [attr.aria-label]="customField | translation: 'label': lang"
                [attr.aria-required]="customField.required === 1 && customField.is_read_only === 0"
                [attr.aria-invalid]="customFieldControl.touched && customFieldControl.invalid"
                [attr.aria-describedby]="customField.id + '_error_' + innerIndex"
                [attr.aria-disabled]="!isEditAllowed || deactivateField"
              >
              @if (customFieldControl?.touched && customFieldControl?.invalid) {
                <div
                  class="text-danger"
                  [id]="customField.id + '_error_' + innerIndex"
                  role="alert"
                  aria-live="polite"
                >
                  @if (customFieldControl?.errors?.required) {
                    {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang | calioTranslateResolver: { text: customField | translation: 'label': lang }) }}
                  } @else if (customFieldControl?.errors?.maxlength) {
                    {{ 'error_messages.maximum_chars_error_message' | translate: { requiredLength: customField.max_characters } }}
                  } @else if (customFieldControl?.errors?.minlength) {
                    {{ 'error_messages.minimum_chars_error_message' | translate: { requiredLength: customField.min_characters } }}
                  } @else if (customFieldControl?.errors?.pattern) {
                    @if (customField?.validation_message) {
                      {{ customField | translation: 'validation_message': lang }}
                    } @else if (!customField?.validation_message) {
                      {{ 'error_messages.invalid_error_message' | translate }}
                    }
                  } @else if (customFieldControl?.errors?.phishingLinkDetected) {
                    {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.ERROR_MESSAGE_PHISHING_LINKS_INPUT, type: 'template' }) | translation: 'template_content': lang) }}
                  }
                </div>
              }
            </div>
          }
        </div>
      }
      @case (customFieldConst.CUSTOM_FIELD_TEXT_AREA) {
        <div class="mt-3 row" role="region" [attr.aria-label]="customField | translation: 'label': lang">
          <ng-container [ngTemplateOutlet]="labelsTemplate"></ng-container>
          @for (element of columnRangeArray; track $index; let innerIndex = $index) {
            <div [class]="'border-end no-right-border-last-child border-sm-right-none mt-3 mt-md-0 mt-no-first-child col-md-'+ (12 / columnRangeCount)">
              @if (parentField?.generate_entity_count) {
                <ng-container
                  [ngTemplateOutlet]="entityNameTemplate"
                  [ngTemplateOutletContext]="{
                    $implicit: innerIndex,
                    widgetConf: widgetConf
                  }"
                />
              }
              <textarea
                [id]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                [name]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                type="text"
                class="form-control"
                [placeholder]="customField.is_multi_language === 1 ?  (customField | translation: 'placeholder': lang) : (customField.placeholder ? customField.placeholder : '')"
                rows="4"
                [(ngModel)]="customField.customerSelectedValue[innerIndex]"
                #customFieldControl="ngModel"
                phishingProtection
                [disabled]="!isEditAllowed || deactivateField"
                [required]="customField.required === 1  && customField.is_read_only === 0"
                [minlength]="customField.min_characters > 0 ? customField.min_characters : null"
                [maxlength]="customField.max_characters > 0 ? customField.max_characters : null"
                (blur)="onChangeCustomFieldSelectedValue(); onBlurCustomFieldSelectedValue();"
                [attr.aria-label]="customField | translation: 'label': lang"
                [attr.aria-required]="customField.required === 1 && customField.is_read_only === 0"
                [attr.aria-invalid]="customFieldControl.touched && customFieldControl.invalid"
                [attr.aria-describedby]="customField.id + '_error_' + innerIndex"
                [attr.aria-disabled]="!isEditAllowed || deactivateField"
              ></textarea>
              @if (customFieldControl.touched && customFieldControl.invalid) {
                <div
                  class="text-danger"
                  [id]="customField.id + '_error_' + innerIndex"
                  role="alert"
                  aria-live="polite"
                >
                  @if (customFieldControl?.errors?.required) {
                    {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang | calioTranslateResolver: { text: customField | translation: 'label': lang }) }}
                  } @else if (customFieldControl?.errors?.maxlength) {
                    {{ 'error_messages.maximum_chars_error_message' | translate: { requiredLength: customField.max_characters } }}
                  } @else if (customFieldControl?.errors?.minlength) {
                    {{ 'error_messages.minimum_chars_error_message' | translate: { requiredLength: customField.min_characters } }}
                  } @else if (customFieldControl?.errors?.phishingLinkDetected) {
                    {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.ERROR_MESSAGE_PHISHING_LINKS_INPUT, type: 'template' }) | translation: 'template_content': lang) }}
                  }
                </div>
              }
            </div>
          }
        </div>
      }
      @case (customFieldConst.CUSTOM_FIELD_CHECKBOX) {
        <div class="mt-3 row" role="region" [attr.aria-label]="customField | translation: 'label': lang">
          <ng-container [ngTemplateOutlet]="labelsTemplate" />
          @for (element of columnRangeArray; track $index; let innerIndex = $index) {
            <div [class]="'border-end no-right-border-last-child border-sm-right-none mt-3 mt-md-0 mt-no-first-child col-md-'+ (12 / columnRangeCount)">
              @if (parentField?.generate_entity_count) {
                <ng-container
                  [ngTemplateOutlet]="entityNameTemplate"
                  [ngTemplateOutletContext]="{
                    $implicit: innerIndex,
                    widgetConf: widgetConf
                  }"
                />
              }
              <div class="d-flex justify-content-between">
                <div class="custom-control custom-checkbox">
                  <input
                    [id]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                    [name]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                    type="checkbox"
                    class="custom-control-input"
                    [(ngModel)]="customField.customerSelectedValue[innerIndex]"
                    #customFieldControl="ngModel"
                    (ngModelChange)="onCheckBoxFieldChange($event)"
                    [disabled]="!isEditAllowed || deactivateField"
                    [required]="customField.required === 1  && customField.is_read_only === 0"
                    [attr.aria-label]="customField | translation: 'label': lang"
                    [attr.aria-required]="customField.required === 1 && customField.is_read_only === 0"
                    [attr.aria-invalid]="customFieldControl.touched && customFieldControl.invalid"
                    [attr.aria-describedby]="customField.id + '_error_' + innerIndex"
                    [attr.aria-disabled]="!isEditAllowed || deactivateField"
                  >
                  @if (customField.is_multi_language === 1) {
                    <label
                      [for]="customField.id + '_' + innerIndex"
                      class="custom-control-label ps-2"
                      [id]="customField.id + '_label_' + innerIndex"
                    >
                      <span [innerHTML]="customField | translation: 'label': lang | calioSafe: 'html'"></span>
                      @if (customField.required === 1) {
                        <span aria-hidden="true"> *</span>
                      }
                    </label>
                  }
                  @if (customField.is_multi_language === 0) {
                    <label
                      [for]="customField.id + '_' + innerIndex"
                      class="custom-control-label ps-2"
                      [id]="customField.id + '_label_' + innerIndex"
                    >
                      <span [innerHTML]="customField.label | calioSafe: 'html'"></span>
                      @if (customField.required === 1) {
                        <span aria-hidden="true"> *</span>
                      }
                    </label>
                  }
                </div>
              </div>
              @if (customFieldControl.touched && customFieldControl.invalid) {
                <div
                  class="text-danger"
                  [id]="customField.id + '_error_' + innerIndex"
                  role="alert"
                  aria-live="polite"
                >
                  @if (customFieldControl.errors?.required) {
                    {{ (bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang | calioTranslateResolver: { text: customField | translation: 'label': lang } }}
                  }
                </div>
              }
            </div>
          }
        </div>
      }
      @case (customFieldConst.CUSTOM_FIELD_RADIO) {
        <div class="mt-3 row" role="radiogroup" [attr.aria-labelledby]="customField.id + '_label'" [attr.aria-describedby]="customField.id + '_description'">
          <ng-container [ngTemplateOutlet]="labelsTemplate"></ng-container>
          @for (element of columnRangeArray; track $index; let innerIndex = $index) {
            <div [class]="'border-end no-right-border-last-child border-sm-right-none mt-3 mt-md-0 mt-no-first-child col-md-'+ (12 / columnRangeCount)">
              @if (parentField?.generate_entity_count) {
                <ng-container
                  [ngTemplateOutlet]="entityNameTemplate"
                  [ngTemplateOutletContext]="{
                    $implicit: innerIndex,
                    widgetConf: widgetConf
                  }"
                />
              }
              @for (custom_field_option of customField.custom_field_options[innerIndex]; track custom_field_option) {
                @if (custom_field_option.id != null) {
                  <div class="d-flex align-items-center mt-1 radio-item">
                    <input
                      [id]="customField.id + '_' + custom_field_option.id + '_' + innerIndex"
                      [name]="customField.id + '_' + innerIndex"
                      type="radio"
                      [value]="custom_field_option.id"
                      [checked]="customField.customerSelectedValue[innerIndex] === custom_field_option.id"
                      (change)="onRadioValueChanged(custom_field_option, true, innerIndex)"
                      [attr.disabled]="(!isEditAllowed || deactivateField) ? true: null"
                      [disabled]="!isEditAllowed || deactivateField"
                      [required]="customField.required === 1  && customField.is_read_only === 0"
                      [(ngModel)]="customField.customerSelectedValue[innerIndex]"
                      #customFieldControl="ngModel"
                      [attr.aria-label]="custom_field_option | translation: 'label': lang"
                      [attr.aria-required]="customField.required === 1 && customField.is_read_only === 0"
                    >
                    <label
                      class="radio-button-label"
                      [for]="customField.id + '_' + custom_field_option.id + '_' + innerIndex"
                      [id]="customField.id + '_label_' + custom_field_option.id + '_' + innerIndex"
                    >
                      <span [innerHTML]="(custom_field_option | translation: 'label': lang) | calioSafe: 'html'"></span>
                    </label>
                  </div>
                }
              }
            </div>
          }
        </div>
        @if (customField?.showEndOfProcess === true) {
          <ng-container
            [ngTemplateOutlet]="endOfProcessBlock"
            [ngTemplateOutletContext]="{ customClass: { 'mt-3': true } }"
          />
        }
        @if (customField.generate_entity_count && customField?.showEndOfProcess === false) {
          <ng-container
            [ngTemplateOutlet]="entityNameFieldTemplate"
            [ngTemplateOutletContext]="{
              $implicit: customField.generate_entity_count,
              widgetConf: widgetConf
            }"
          />
        }
      }
      @case (customFieldConst.CUSTOM_FIELD_DATE) {
        <div class="mt-3 row csw-date-field" role="region" [attr.aria-label]="customField | translation: 'label': lang">
          <ng-container [ngTemplateOutlet]="labelsTemplate" />
          @for (element of columnRangeArray; track $index; let innerIndex = $index) {
            <div [class]="'border-end no-right-border-last-child border-sm-right-none mt-3 mt-md-0 mt-no-first-child col-md-'+ (12 / columnRangeCount)">
              @if (parentField?.generate_entity_count) {
                <ng-container [ngTemplateOutlet]="entityNameTemplate" [ngTemplateOutletContext]="{ $implicit: innerIndex, widgetConf: widgetConf }" />
              }
              <mat-form-field>
                <input
                  [id]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                  [name]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                  matInput
                  [matDatepicker]="picker"
                  [(ngModel)]="selectedDate[innerIndex]"
                  #dateModel="ngModel"
                  [disabled]="!isEditAllowed || deactivateField"
                  [required]="customField.required === 1 && customField.is_read_only === 0"
                  (dateChange)="onChangeDate($event, innerIndex)"
                  [attr.aria-label]="customField | translation: 'label': lang"
                  [attr.aria-required]="customField.required === 1 && customField.is_read_only === 0"
                  [attr.aria-invalid]="dateModel.touched && dateModel.invalid"
                  [attr.aria-describedby]="customField.id + '_error_' + innerIndex"
                  [attr.aria-disabled]="!isEditAllowed || deactivateField"
                  [attr.aria-haspopup]="'dialog'"
                  [attr.aria-controls]="customField.id + '_picker_' + innerIndex"
                >
                <mat-datepicker-toggle
                  class="pb-2"
                  matSuffix
                  [for]="picker"
                  [attr.aria-label]="'Open date picker for ' + (customField | translation: 'label': lang)"
                />
                <mat-datepicker
                  #picker
                  [id]="customField.id + '_picker_' + innerIndex"
                  [attr.aria-label]="customField | translation: 'label': lang + ' date picker'"
                />
              </mat-form-field>
              @if (dateModel.touched && dateModel.invalid) {
                <div
                  class="text-danger"
                  [id]="customField.id + '_error_' + innerIndex"
                  role="alert"
                  aria-live="polite"
                >
                  @if (dateModel.errors?.required) {
                    {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang | calioTranslateResolver: { text: customField | translation: 'label': lang }) }}
                  }
                </div>
              }
            </div>
          }
        </div>
      }
      @case (customFieldConst.CUSTOM_FIELD_INFORMATION) {
        <div class="mt-3" role="alert" [attr.aria-label]="customField | translation: 'title': lang">
          <div class="alert"
            [ngClass]="{
              'alert-danger': customField.color === 'red',
              'alert-primary': customField.color === 'blue',
              'alert-warning': customField.color === 'yellow',
              'alert-light': customField.color === 'neutral'
            }"
            [attr.aria-label]="customField | translation: 'title': lang"
          >
            @if (customField.is_multi_language === 1) {
              @if ((customField | translation: 'title': lang) | isEmptyString) {
                <div class="heading" role="heading" aria-level="2">
                  <span [innerHTML]="(customField | translation: 'title': lang) | calioSafe: 'html'"></span>
                </div>
              }
              @if ((customField | translation: 'label': lang) | isEmptyString) {
                <div class="d-flex justify-content-between">
                  <label [for]="customField.id" [ngClass]="{ 'input-label-1': ((customField | translation: 'title': lang) | isEmptyString) }" [id]="customField.id + '_label'">
                    <span [innerHTML]="(customField | translation: 'label': lang) | calioSafe: 'html'"></span>
                  </label>
                </div>
              }
            }
            @if (customField.is_multi_language === 0) {
              @if ((customField.title | isEmptyString)) {
                <div class="heading" role="heading" aria-level="2">
                  <span [innerHTML]="customField.title | calioSafe: 'html'"></span>
                </div>
              }
              @if ((customField.label | isEmptyString)) {
                <div class="d-flex justify-content-between">
                  <label [for]="customField.id" [ngClass]="{ 'input-label-1': (customField.title | isEmptyString) }" [id]="customField.id + '_label'">
                    <span [innerHTML]="customField.label | calioSafe: 'html'"></span>
                  </label>
                </div>
              }
            }
          </div>
        </div>
      }
      @case (customFieldConst.CUSTOM_FIELD_IMAGE_SELECT_CARD) {
        <div class="mt-3 row" role="region" [attr.aria-label]="customField | translation: 'label': lang">
          <div class="col-md-12">
            @if (!isEditAllowed) {
              <div class="alert alert-warning" role="alert">
                {{ 'error_messages.custom_field_as_readonly' | translate }}
              </div>
            }
          </div>
          <ng-container [ngTemplateOutlet]="labelsTemplate" />
        </div>
        <div class="image-card-select-options row" role="group" [attr.aria-labelledby]="customField.id + '_label'">
          @if (parentField?.generate_entity_count && columnRangeCount > 1) {
            @if (customField.required === 1 && customField.is_read_only === 0 && !validImageSelect) {
              <div class="col-md-12 summary-warning">
                <div class="alert alert-danger" role="alert" aria-live="polite">
                  {{ 'error_messages.image_select_required_error' | translate }}
                </div>
              </div>
            }
            <div class="col-md-12 mb-3">
              <span id="entity-selector-label">
                {{ 'survey_component.image_select_entity_selector' | translate }}
              </span>
              <ng-select
                name="imageSeletEntitySelectorSelectbox"
                [clearable]="false"
                [selectOnTab]="true"
                [openOnEnter]="true"
                #imageSelectEntitySelectorModel="ngModel"
                [(ngModel)]="imageSelectEntitySelector"
                [attr.aria-label]="'survey_component.image_select_entity_selector' | translate"
                role="combobox"
                [attr.aria-haspopup]="'listbox'"
                [attr.aria-expanded]="false"
              >
                @for (entity of columnRangeArray; track entity; let innerIndex = $index) {
                  <ng-option [value]="innerIndex" role="option" [attr.aria-label]="">
                      {{ (parentField.entity_names[innerIndex] ? parentField.entity_names[innerIndex] : 'survey_component.entity_name_label' | translate: {number: (innerIndex+1)} ) }}
                  </ng-option>
                }
              </ng-select>
            </div>
          }
          @for (element of columnRangeArray; track $index; let innerIndex = $index) {
            <div
              [class]="'col-md-12 entity-image-select-options options-slot-' + innerIndex"
              [ngClass]="{ 'd-none': innerIndex !== imageSelectEntitySelector }"
              role="group"
            >
              <div class="row csw-cf-{{customField.id}}">
                @for (option of customField.custom_field_options[innerIndex]; track option) {
                  <div
                    class="mb-4 image-options"
                    [ngClass]="{
                      'col-md-6': option.is_fullscreen_image === 1,
                      'col-md-3': option.is_fullscreen_image !== 1
                    }"
                  >
                    <app-info-card
                      [showCardBorder]="true"
                      [showShadow]="false"
                      [showImage]="true"
                      [showBody]="true"
                      [showCursorPointer]="true"
                      [isSelected]="(
                        customField?.customerSelectedValue[innerIndex] &&
                        customField?.customerSelectedValue[innerIndex]?.indexOf(option.id) > -1
                      )"
                      [selectedCardColor]="widgetService?.widgetConf?.header_background_color"
                      [customCardStylesConfig]="{ borderRadius: '0px' }"
                      (cardClickEvent)="onCardImageCustomField(null, option, innerIndex)"
                      role="checkbox"
                      [attr.aria-checked]="customField?.customerSelectedValue[innerIndex]?.indexOf(option.id) > -1"
                      [attr.aria-label]="option | translation: 'label': lang"
                      [attr.aria-disabled]="!isEditAllowed || deactivateField"
                    >
                      <div class="cursor-pointer" cardImage>
                        <img
                          #imageSelectionOption
                          [src]="option.image"
                          [ngClass]="{
                            'card-img-top': option.is_fullscreen_image === 1,
                            'icon-img': option.is_fullscreen_image !== 1
                          }"
                          [attr.alt]="option | translation: 'label': lang"
                        />
                      </div>
                      <div class="cursor-pointer" cardBody>
                        <div class="d-flex align-items-center">
                          <mat-checkbox
                            class="cursor-pointer w-100"
                            [ngClass]="{ 'has-card-info-url': (option?.info_url ? true : false) }"
                            #checkboxModel
                            [disableRipple]="true"
                            [checked]="(
                              customField?.customerSelectedValue[innerIndex] &&
                              customField?.customerSelectedValue[innerIndex]?.indexOf(option.id) > -1
                            )"
                            [(ngModel)]="option.customerSelectedValue"
                            name="image_card_option"
                            [disabled]="!isEditAllowed || deactivateField"
                            [attr.aria-label]="option | translation: 'label': lang"
                            [attr.aria-required]="customField.required === 1 && customField.is_read_only === 0"
                          >
                            <div class="d-flex justify-content-between image-title-block">
                              <div class="d-flex flex-column">
                                @if ((option | translation: 'title': lang)) {
                                  <div class="mb-1 option-title" role="heading" aria-level="3">
                                    {{ option | translation: 'title': lang }}
                                  </div>
                                }
                                <div
                                  class="label"
                                  [ngClass]="{
                                    'text-muted': (option | translation: 'title': lang),
                                    'option-title': !(option | translation: 'title': lang)
                                  }"
                                >
                                  {{ option | translation: 'label': lang }}
                                </div>
                              </div>
                              @if (option.is_fullscreen_image === 1) {
                                <div class="d-flex justify-content-end">
                                  <span [ngClass]="{ 'me-2': option?.info_url ? true : false }">
                                    <a
                                      href="javascript:void(0);"
                                      (click)="openImagePopup(option, imageSelectionOption); $event.stopImmediatePropagation();"
                                      role="button"
                                      [attr.aria-label]="'View full screen image of ' + (option | translation: 'label': lang)"
                                    >
                                      <img
                                        class="view-image-icon"
                                        [src]="deployUrl + 'assets/images/icons/full-screen.svg'"
                                        alt="View full screen"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </span>
                                  @if ((option?.info_url | isEmptyString)) {
                                    <span [ngClass]="{ 'me-2': option?.youtube_url ? true : false }">
                                      <a
                                        target="_blank"
                                        [href]="option?.info_url"
                                        (click)="$event.stopImmediatePropagation()"
                                        role="button"
                                        [attr.aria-label]="'More information about ' + (option | translation: 'label': lang)"
                                      >
                                        <img
                                          [src]="deployUrl + 'assets/images/icons/info-filled-icon.svg'"
                                          alt="Information"
                                          aria-hidden="true"
                                        />
                                      </a>
                                    </span>
                                  }
                                  @if ((option?.youtube_url | isEmptyString)) {
                                    <span>
                                      <a
                                        #youtubeElement
                                        href="javascript:void(0)"
                                        (click)="openYoutubeVideo(option, youtubeElement); $event.stopImmediatePropagation();"
                                        role="button"
                                        [attr.aria-label]="'Watch YouTube video about ' + (option | translation: 'label': lang)"
                                      >
                                        <img
                                          class="youtube-icon"
                                          [src]="deployUrl + 'assets/images/logo/youtube_social_icon_red.png'"
                                          alt="YouTube"
                                          aria-hidden="true"
                                        />
                                      </a>
                                    </span>
                                  }
                                </div>
                              }
                            </div>
                          </mat-checkbox>
                          @if (option.is_fullscreen_image !== 1) {
                            @if ((option?.info_url | isEmptyString)) {
                              <span class="card-info-url">
                                <a
                                  target="_blank"
                                  [href]="option?.info_url"
                                  (click)="$event.stopImmediatePropagation()"
                                  role="button"
                                  [attr.aria-label]="'More information about ' + (option | translation: 'label': lang)"
                                >
                                  <img
                                    [src]="deployUrl + 'assets/images/icons/info-filled-icon.svg'"
                                    alt="Information"
                                    aria-hidden="true"
                                  />
                                </a>
                              </span>
                            }
                            @if ((option?.youtube_url | isEmptyString)) {
                              <span class="select-card-youtube-url">
                                <a
                                  #youtubeElement
                                  href="javascript:void(0)"
                                  (click)="openYoutubeVideo(option, youtubeElement); $event.stopImmediatePropagation();"
                                  role="button"
                                  [attr.aria-label]="'Watch YouTube video about ' + (option | translation: 'label': lang)"
                                >
                                  <img
                                    class="youtube-icon"
                                    [src]="deployUrl + 'assets/images/logo/youtube_social_icon_red.png'"
                                    alt="YouTube"
                                    aria-hidden="true"
                                  />
                                </a>
                              </span>
                            }
                          }
                        </div>
                      </div>
                    </app-info-card>
                  </div>
                }
                <div class="col-sm-12">
                  <input
                    hidden
                    [id]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                    [name]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                    [required]="customField.required === 1 && customField.is_read_only === 0"
                    [(ngModel)]="customField.customerSelectedValue[innerIndex]"
                    #customFieldSelect="ngModel"
                    class="form-control cbw-input-field"
                    [attr.aria-hidden]="true"
                  >
                  @if (customFieldSelect.touched && !customFieldSelect.valid) {
                    <div
                      class="alert alert-danger summary-warning mt-1"
                      role="alert"
                      aria-live="polite"
                    >
                      @if (customFieldSelect.errors?.required) {
                        {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang | calioTranslateResolver: { text: customField | translation: 'label': lang }) }}
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        @if (customField?.showEndOfProcess === true) {
          <ng-container [ngTemplateOutlet]="endOfProcessBlock" />
        }
        @if (customField.generate_entity_count && customField?.showEndOfProcess === false) {
          <ng-container
            [ngTemplateOutlet]="entityNameFieldTemplate"
            [ngTemplateOutletContext]="{
              $implicit: customField.generate_entity_count,
              widgetConf: widgetConf
            }"
          />
        }
      }
      @case (customFieldConst.CUSTOM_FIELD_SELECT_CARD) {
        <div class="mt-3 row" role="region" [attr.aria-label]="customField | translation: 'label': lang">
          <div class="col-md-12">
            @if (!isEditAllowed) {
              <div class="alert alert-warning" role="alert">
                {{ 'error_messages.custom_field_as_readonly' | translate }}
              </div>
            }
          </div>
          <ng-container [ngTemplateOutlet]="labelsTemplate" />
        </div>
        <div class="image-card-select-options row csw-cf-{{customField.id}}" role="group" [attr.aria-labelledby]="customField.id + '_label'">
          @for (element of columnRangeArray; track $index; let innerIndex = $index) {
            <div [class]="'border-end no-right-border-last-child border-sm-right-none col-md-'+ (12 / columnRangeCount)" role="group">
              @if (parentField?.generate_entity_count) {
                <ng-container
                  [ngTemplateOutlet]="entityNameTemplate"
                  [ngTemplateOutletContext]="{
                    $implicit: innerIndex,
                    widgetConf: widgetConf
                  }"
                />
              }
              <div class="row">
                @for (option of customField.custom_field_options[innerIndex]; track option) {
                  <div
                    class="mb-4"
                    [ngClass]="{
                      'col-md-3': columnRangeCount == 1,
                      'col-md-6': (columnRangeCount > 1 && columnRangeCount <= 2),
                      'col-md-12': columnRangeCount >= 3
                    }"
                  >
                    <app-info-card
                      [showCardBorder]="true"
                      [showShadow]="false"
                      [showBody]="true"
                      [showCursorPointer]="true"
                      [isSelected]="(
                        customField?.customerSelectedValue[innerIndex] &&
                        customField?.customerSelectedValue[innerIndex]?.indexOf(option.id) > -1
                      )"
                      [selectedCardColor]="widgetService?.widgetConf?.header_background_color"
                      [customCardStylesConfig]="{ borderRadius: '0px' }"
                      (cardClickEvent)="onCardImageCustomField(null, option, innerIndex)"
                      role="checkbox"
                      [attr.aria-checked]="customField?.customerSelectedValue[innerIndex]?.indexOf(option.id) > -1"
                      [attr.aria-label]="option | translation: 'label': lang"
                      [attr.aria-disabled]="!isEditAllowed || deactivateField"
                    >
                      <div class="cursor-pointer" cardBody>
                        <div class="d-flex align-items-center">
                          <mat-checkbox
                            class="cursor-pointer"
                            [ngClass]="{
                              'has-card-info-url': (option?.info_url ? true : false),
                              'additional-padding': (option?.info_url && option?.youtube_url)
                            }"
                            #checkboxModel
                            [disableRipple]="true"
                            [checked]="(
                              customField?.customerSelectedValue[innerIndex] &&
                              customField?.customerSelectedValue[innerIndex]?.indexOf(option.id) > -1
                            )"
                            [(ngModel)]="option.customerSelectedValue"
                            name="image_card_option"
                            [disabled]="!isEditAllowed || deactivateField"
                            [attr.aria-label]="option | translation: 'label': lang"
                            [attr.aria-required]="customField.required === 1 && customField.is_read_only === 0"
                          >
                            <div class="d-flex flex-column">
                              @if ((option | translation: 'title': lang)) {
                                <div class="mb-1 option-title" role="heading" aria-level="3">
                                  {{ option | translation: 'title': lang }}
                                </div>
                              }
                              <div
                                [ngClass]="{
                                  'text-muted': (option | translation: 'title': lang),
                                  'option-title': !(option | translation: 'title': lang)
                                }"
                              >
                                {{ option | translation: 'label': lang }}
                              </div>
                            </div>
                          </mat-checkbox>
                          @if ((option?.info_url | isEmptyString)) {
                            <span class="card-info-url">
                              <a
                                target="_blank"
                                [href]="option?.info_url"
                                (click)="$event.stopImmediatePropagation()"
                                role="button"
                                [attr.aria-label]="'More information about ' + (option | translation: 'label': lang)"
                              >
                                <img
                                  [src]="deployUrl + 'assets/images/icons/info-filled-icon.svg'"
                                  alt="Information"
                                  aria-hidden="true"
                                />
                              </a>
                            </span>
                          }
                          @if ((option?.youtube_url | isEmptyString)) {
                            <span class="select-card-youtube-url">
                              <a
                                #youtubeElement
                                href="javascript:void(0)"
                                (click)="openYoutubeVideo(option, youtubeElement); $event.stopImmediatePropagation();"
                                role="button"
                                [attr.aria-label]="'Watch YouTube video about ' + (option | translation: 'label': lang)"
                              >
                                <img
                                  class="youtube-icon"
                                  [src]="deployUrl + 'assets/images/logo/youtube_social_icon_red.png'"
                                  alt="YouTube"
                                  aria-hidden="true"
                                />
                              </a>
                            </span>
                          }
                        </div>
                      </div>
                    </app-info-card>
                  </div>
                }
                <div class="col-sm-12">
                  <input
                    [id]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                    [name]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                    hidden
                    [required]="customField.required === 1 && customField.is_read_only === 0"
                    [(ngModel)]="customField.customerSelectedValue[innerIndex]"
                    #customFieldSelect="ngModel"
                    class="form-control cbw-input-field"
                  >
                  @if (customFieldSelect.touched && !customFieldSelect.valid) {
                    <div
                      class="alert alert-danger summary-warning mt-1"
                      role="alert"
                      aria-live="polite"
                    >
                      @if (customFieldSelect.errors?.required) {
                        {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang | calioTranslateResolver: { text: customField | translation: 'label': lang }) }}
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        @if (customField?.showEndOfProcess === true) {
          <ng-container [ngTemplateOutlet]="endOfProcessBlock" />
        }
        @if (customField.generate_entity_count && customField?.showEndOfProcess === false) {
          <ng-container
            [ngTemplateOutlet]="entityNameFieldTemplate"
            [ngTemplateOutletContext]="{
              $implicit: customField.generate_entity_count,
              widgetConf: widgetConf
            }"
          />
        }
      }
      @case (customFieldConst.CUSTOM_FIELD_NUMBER_SELECT_CARD) {
        <div class="mt-3 row" role="region" [attr.aria-label]="customField | translation: 'label': lang">
          <div class="col-md-12">
            @if (!isEditAllowed) {
              <div class="alert alert-warning" role="alert">
                {{ 'error_messages.custom_field_as_readonly' | translate }}
              </div>
            }
          </div>
          <ng-container [ngTemplateOutlet]="labelsTemplate" />
        </div>
        <div class="number-card-select-options row csw-cf-{{customField.id}}" role="group" [attr.aria-labelledby]="customField.id + '_label'">
          @for (element of columnRangeArray; track $index; let innerIndex = $index) {
            <div [class]="'border-end no-right-border-last-child border-sm-right-none col-md-'+ (12 / columnRangeCount)" role="group">
              @if (parentField?.generate_entity_count) {
                <ng-container
                  [ngTemplateOutlet]="entityNameTemplate"
                  [ngTemplateOutletContext]="{
                    $implicit: innerIndex,
                    widgetConf: widgetConf
                  }"
                />
              }
              <div class="row">
                @for (option of customField.custom_field_options[innerIndex]; track option) {
                  <div
                    class="mb-4"
                    [ngClass]="{
                      'col-lg-6 col-md-6': columnRangeCount <= 1,
                      'col-md-12': columnRangeCount > 1
                    }"
                  >
                    <app-info-card
                      [showCardBorder]="true"
                      [showShadow]="false"
                      [showBody]="true"
                      [customCardStylesConfig]="{ borderRadius: '0px' }"
                      role="group"
                      [attr.aria-label]="option | translation: 'label': lang"
                    >
                      <div class="cursor-pointer" cardBody>
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="d-flex flex-column">
                            @if ((option | translation: 'title': lang)) {
                              <div class="mb-1 option-title" role="heading" aria-level="3">
                                {{ option | translation: 'title': lang }}
                              </div>
                            }
                            <div
                              [ngClass]="{
                                'text-muted': (option | translation: 'title': lang),
                                'option-title': !(option | translation: 'title': lang)
                              }"
                            >
                              {{ option | translation: 'label': lang }}
                            </div>
                          </div>
                          <div class="d-flex align-items-center" role="spinbutton" [attr.aria-valuemin]="option.number_min" [attr.aria-valuemax]="option.number_max" [attr.aria-valuenow]="option?.option_value" [attr.aria-label]="option | translation: 'label': lang">
                            <button
                              type="button"
                              [disabled]="(option.number_min === option?.option_value || option?.option_value < option.number_min) || !isEditAllowed"
                              class="btn btn-link d-flex align-items-center justify-content-center rounded-icon"
                              (click)="reduceNumberCardValue(option, innerIndex)"
                              [attr.aria-label]="'Decrease value for ' + (option | translation: 'label': lang)"
                            >
                              <mat-icon class="minus-solid" svgIcon="minus-solid" aria-hidden="true" />
                            </button>
                            <span class="px-4" aria-hidden="true">{{ option?.option_value }}</span>
                            <button
                              type="button"
                              [disabled]="(option.number_max === option?.option_value || option?.option_value > option.number_max) || !isEditAllowed"
                              class="btn btn-link d-flex align-items-center justify-content-center rounded-icon"
                              (click)="addNumberCardValue(option, innerIndex)"
                              [attr.aria-label]="'Increase value for ' + (option | translation: 'label': lang)"
                            >
                              <mat-icon class="plus-solid" svgIcon="plus-solid" aria-hidden="true" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </app-info-card>
                  </div>
                }
                <div class="col-sm-12">
                  <input
                    hidden
                    [required]="customField.required === 1 && customField.is_read_only === 0"
                    [(ngModel)]="customField.customerSelectedValue[innerIndex]"
                    #customFieldSelect="ngModel"
                    [id]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                    [name]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                    class="form-control cbw-input-field"
                  >
                  @if (customFieldSelect.touched && !customFieldSelect.valid) {
                    <div
                      class="alert alert-danger summary-warning mt-1"
                      role="alert"
                      aria-live="polite"
                    >
                      @if (customFieldSelect.errors?.required) {
                        {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang | calioTranslateResolver: { text: customField | translation: 'label': lang }) }}
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
      @case (customFieldConst.CUSTOM_FIELD_FILE) {
        <div class="mt-3 row" role="region" [attr.aria-label]="customField | translation: 'label': lang">
          <ng-container [ngTemplateOutlet]="labelsTemplate" />
          @for (element of columnRangeArray; track $index; let innerIndex = $index) {
            <div [class]="'border-end no-right-border-last-child border-sm-right-none col-md-'+ (12 / columnRangeCount)" role="group">
              @if (parentField?.generate_entity_count) {
                <ng-container
                  [ngTemplateOutlet]="entityNameTemplate"
                  [ngTemplateOutletContext]="{
                    $implicit: innerIndex,
                    widgetConf: widgetConf
                  }"
                />
              }
              <div class="input-group">
                <input
                  [id]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                  [name]="customField.id + '_' + (customEventIndex ? customEventIndex : innerIndex)"
                  type="file"
                  class="form-control input-file"
                  [placeholder]="customField.is_multi_language === 1 ?  (customField | translation: 'placeholder': lang) : (customField.placeholder ? customField.placeholder : '')"
                  [(ngModel)]="customField.customerSelectedInputValue[innerIndex]"
                  #customFieldControl="ngModel"
                  (change)="onFileChanged($event, innerIndex)"
                  [multiple]="(customField.is_multiple_file === 1)"
                  [disabled]="customField.is_read_only === 1 || (customField?.is_multiple_file === 0 && customField?.customerSelectedFileValue[innerIndex]?.length === 1) || !isEditAllowed || deactivateField"
                  [accept]="customField.customSupportedMimeType"
                  [required]="(customField.required === 1  && customField.is_read_only === 0 && (!customField.customerSelectedValue[innerIndex] || customField.customerSelectedValue[innerIndex]?.length === 0))"
                  [attr.aria-label]="customField | translation: 'label': lang"
                  [attr.aria-required]="customField.required === 1 && customField.is_read_only === 0"
                  [attr.aria-invalid]="customFieldControl.touched && customFieldControl.invalid"
                  [attr.aria-describedby]="customField.id + '_error_' + innerIndex + ' ' + customField.id + '_helper_' + innerIndex"
                  [attr.aria-disabled]="!isEditAllowed || deactivateField"
                >
              </div>
              @if (customField.is_multiple_file === 1) {
                <small
                  class="form-text text-muted"
                  [id]="customField.id + '_helper_' + innerIndex"
                >
                  {{ 'error_messages.multiple_file_upload_helper_text' | translate }}
                </small>
              } @else if (customField.is_multiple_file === 0) {
                <small
                  class="form-text text-muted"
                  [id]="customField.id + '_helper_' + innerIndex"
                >
                  {{ 'error_messages.single_file_upload_helper_text' | translate }}
                </small>
              }
              @if (waitForFileUpload[innerIndex]) {
                <div
                  class="text-danger"
                  role="alert"
                  aria-live="polite"
                >
                  <div>
                    {{ 'error_messages.file_uploading' | translate }}
                  </div>
                </div>
              }
              @if (customFieldControl.touched && customFieldControl.invalid) {
                <div
                  class="text-danger"
                  [id]="customField.id + '_error_' + innerIndex"
                  role="alert"
                  aria-live="polite"
                >
                  @if (customFieldControl?.errors?.required) {
                    {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang | calioTranslateResolver: { text: customField | translation: 'label': lang }) }}
                  }
                </div>
              }
              @if (customField.errorMessage?.[innerIndex]) {
                <div
                  class="text-danger"
                  role="alert"
                  aria-live="polite"
                >
                  {{ customField.errorMessage[innerIndex] | translate: { fileLength: 5 } }}
                </div>
              }
              <div>
                <ul class="ps-0 mt-2 file-list" role="list" [attr.aria-label]="'Uploaded files for ' + (customField | translation: 'label': lang)">
                  @for (file of customField.customerSelectedFileValue[innerIndex]; track file; let i = $index) {
                    <li class="pt-1" role="listitem">
                      <div class="d-flex align-items-center justify-content-between">
                        <span>
                          @if (widgetService.layoutType !== 'CHATBOX') {
                            <a
                              class="ahref"
                              [href]="file?.file?.full_path"
                              target="_blank"
                              [attr.aria-label]="'Download ' + file?.file?.origin_filename"
                            >
                              {{ file?.file?.origin_filename }}
                            </a>
                          }
                          @if (widgetService.layoutType === 'CHATBOX') {
                            <app-csw-link
                              [isLink]="true"
                              [styleConfig]="{
                                'color': widgetService?.widgetConf?.header_background_color,
                                'textDecorationColor': widgetService?.widgetConf?.header_background_color
                              }"
                              [link]="file?.file?.full_path"
                              [text]="file?.file?.origin_filename"
                              [attr.aria-label]="'Download ' + file?.file?.origin_filename"
                            />
                          }
                        </span>
                        @if (isEditAllowed) {
                          <span
                            class="file-trash-icon cursor-pointer"
                            (click)="deleteFile(file, i, innerIndex)"
                            role="button"
                            [attr.aria-label]="'Delete ' + file?.file?.origin_filename"
                            tabindex="0"
                          >
                            <mat-icon class="button-icon" svgIcon="times-solid" aria-hidden="true" />
                          </span>
                        }
                      </div>
                    </li>
                  }
                </ul>
              </div>
            </div>
          }
        </div>
      }
      @case (customFieldConst.CUSTOM_FIELD_WORKER_SELECT) {
        <div class="mt-3 row custom-worker-select-field" role="region" [attr.aria-label]="customField | translation: 'label': lang">
          <ng-container [ngTemplateOutlet]="labelsTemplate" />
          @for (element of columnRangeArray; track $index; let innerIndex = $index) {
            <div [class]="'border-end no-right-border-last-child border-sm-right-none mt-3 mt-md-0 mt-no-first-child col-md-'+ (12 / columnRangeCount)" role="group">
              @if (parentField?.generate_entity_count) {
                <ng-container
                  [ngTemplateOutlet]="entityNameTemplate"
                  [ngTemplateOutletContext]="{
                    $implicit: innerIndex,
                    widgetConf: widgetConf
                  }"
                />
              }
              <ng-select
                #customFieldControl="ngModel"
                [id]="customField.id + '_' + innerIndex"
                [name]="customField.id + '_' + innerIndex"
                [placeholder]="customField.is_multi_language === 1 ? (customField | translation: 'placeholder': lang) : (customField.placeholder ? customField.placeholder : '')"
                [multiple]="(customField.is_multiple_select === 1)"
                [closeOnSelect]="!(customField.is_multiple_select === 1)"
                [clearable]="!(customField.is_multiple_select === 1)"
                [(ngModel)]="customField.customerSelectedValue[(customEventIndex ? customEventIndex : innerIndex)]"
                (change)="onSelectChange($event, (customEventIndex ? customEventIndex : innerIndex))"
                [readonly]="!isEditAllowed || deactivateField"
                [searchable]="true"
                [required]="customField.required === 1  && customField.is_read_only === 0"
                [ngClass]="{ 'is-invalid': customFieldControl.touched && customFieldControl.invalid }"
                [loading]="customField?.isOptionsAreLoading"
                role="combobox"
                [attr.aria-label]="customField | translation: 'label': lang"
                [attr.aria-required]="customField.required === 1 && customField.is_read_only === 0"
                [attr.aria-invalid]="customFieldControl.touched && customFieldControl.invalid"
                [attr.aria-describedby]="customField.id + '_error_' + innerIndex"
                [attr.aria-expanded]="false"
                [attr.aria-haspopup]="'listbox'"
                [attr.aria-controls]="customField.id + '_listbox_' + innerIndex"
                [attr.aria-disabled]="!isEditAllowed || deactivateField"
              >
                @if (egalWerShowSetting === true) {
                  <ng-option
                    value="null"
                    role="option"
                    [attr.aria-label]="(bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_ANYONE_LABEL, type: 'template' }) | translation: 'template_content': lang"
                  >
                    <div class="worker-option">
                      @if (customField?.show_avatar === 1) {
                        <div class="avatar">
                          <img
                            class="default-avatar rounded-circle"
                            [src]="imagePath + '/img/sample-avatar.png'"
                            alt="Default avatar"
                            aria-hidden="true"
                          />
                        </div>
                      }
                      {{ (bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_ANYONE_LABEL, type: 'template' }) | translation: 'template_content': lang }}
                    </div>
                  </ng-option>
                }
                @for (worker of workers; track worker) {
                  <ng-option
                    [value]="worker.id"
                    role="option"
                    [attr.aria-label]="worker.resource_name"
                    [attr.aria-selected]="customField.customerSelectedValue[innerIndex] === worker.id"
                  >
                    <div class="worker-option">
                      @if (customField?.show_avatar === 1) {
                        <div class="avatar">
                          @if (worker.avatar) {
                            <img
                              #image
                              class="resource-avatar rounded-circle"
                              [src]="workerAvatarBaseUrl + worker.uuid + '/thumb_' + worker.avatar"
                              (error)="image.src= imagePath + '/img/sample-avatar.png'"
                              [attr.alt]="worker.resource_name + ' avatar'"
                              aria-hidden="true"
                            />
                          }
                          @if (!worker.avatar) {
                            <img
                              class="default-avatar rounded-circle"
                              [src]="imagePath + '/img/sample-avatar.png'"
                              alt="Default avatar"
                              aria-hidden="true"
                            />
                          }
                        </div>
                      }
                      {{ worker.resource_name }}
                    </div>
                  </ng-option>
                }
              </ng-select>
              @if (customFieldControl.touched && customFieldControl.invalid) {
                <div
                  class="text-danger"
                  [id]="customField.id + '_error_' + innerIndex"
                  role="alert"
                  aria-live="polite"
                >
                  @if (customFieldControl?.errors?.required) {
                    {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang | calioTranslateResolver: { text: customField | translation: 'label': lang }) }}
                  }
                </div>
              }
            </div>
          }
        </div>
        @if (customField?.showEndOfProcess === true) {
          <ng-container [ngTemplateOutlet]="endOfProcessBlock" />
        }
        @if (customField.generate_entity_count && customField?.showEndOfProcess === false) {
          <ng-container
            [ngTemplateOutlet]="entityNameFieldTemplate"
            [ngTemplateOutletContext]="{
              $implicit: customField.generate_entity_count,
              widgetConf: widgetConf
            }"
          />
        }
      }
      @case (customFieldConst.CUSTOM_FIELD_STORE_SELECT) {
        <div class="mt-3 row custom-worker-select-field" role="region" [attr.aria-label]="customField | translation: 'label': lang">
          <ng-container [ngTemplateOutlet]="labelsTemplate" />
          @for (element of columnRangeArray; track $index; let innerIndex = $index) {
            <div [class]="'border-end no-right-border-last-child border-sm-right-none mt-3 mt-md-0 mt-no-first-child col-md-'+ (12 / columnRangeCount)" role="group">
              @if (parentField?.generate_entity_count) {
                <ng-container
                  [ngTemplateOutlet]="entityNameTemplate"
                  [ngTemplateOutletContext]="{
                    $implicit: innerIndex,
                    widgetConf: widgetConf
                  }"
                />
              }
              <ng-select
                #customFieldControl="ngModel"
                [id]="customField.id + '_' + innerIndex"
                [name]="customField.id + '_' + innerIndex"
                [placeholder]="customField.is_multi_language === 1 ? (customField | translation: 'placeholder': lang) : (customField.placeholder ? customField.placeholder : '')"
                [multiple]="(customField.is_multiple_select === 1)"
                [closeOnSelect]="!(customField.is_multiple_select === 1)"
                [clearable]="!(customField.is_multiple_select === 1)"
                [(ngModel)]="customField.customerSelectedValue[(customEventIndex ? customEventIndex : innerIndex)]"
                (change)="onSelectChange($event, (customEventIndex ? customEventIndex : innerIndex))"
                [readonly]="!isEditAllowed || deactivateField"
                [searchable]="true"
                [required]="customField.required === 1  && customField.is_read_only === 0"
                [ngClass]="{ 'is-invalid': customFieldControl.touched && customFieldControl.invalid }"
                [loading]="customField?.isOptionsAreLoading"
                role="combobox"
                [attr.aria-label]="customField | translation: 'label': lang"
                [attr.aria-required]="customField.required === 1 && customField.is_read_only === 0"
                [attr.aria-invalid]="customFieldControl.touched && customFieldControl.invalid"
                [attr.aria-describedby]="customField.id + '_error_' + innerIndex"
                [attr.aria-expanded]="false"
                [attr.aria-haspopup]="'listbox'"
                [attr.aria-controls]="customField.id + '_listbox_' + innerIndex"
                [attr.aria-disabled]="!isEditAllowed || deactivateField"
              >
                @for (store of stores; track store.id) {
                  <ng-option
                    [value]="store.id"
                    role="option"
                    [attr.aria-label]="store | translation: 'name': lang"
                    [attr.aria-selected]="customField.customerSelectedValue[innerIndex] === store.id"
                  >
                    {{ store | translation: 'name': lang }}
                  </ng-option>
                }
              </ng-select>
              @if (customFieldControl.touched && customFieldControl.invalid) {
                <div
                  class="text-danger"
                  [id]="customField.id + '_error_' + innerIndex"
                  role="alert"
                  aria-live="polite"
                >
                  @if (customFieldControl?.errors?.required) {
                    {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' }) | translation: 'template_content': lang | calioTranslateResolver: { text: customField | translation: 'label': lang }) }}
                  }
                </div>
              }
            </div>
          }
        </div>
        @if (customField?.showEndOfProcess === true) {
          <ng-container [ngTemplateOutlet]="endOfProcessBlock" />
        }
        @if (customField.generate_entity_count && customField?.showEndOfProcess === false) {
          <ng-container
            [ngTemplateOutlet]="entityNameFieldTemplate"
            [ngTemplateOutletContext]="{
              $implicit: customField.generate_entity_count,
              widgetConf: widgetConf
            }"
          />
        }
      }
    }
  </div>
}

<ng-template #entityNameTemplate let-innerIndex let-widgetConf="widgetConf">
  <div
    class="mb-1"
    role="heading"
    aria-level="3"
    [id]="'entity_name_heading_' + innerIndex"
  >
    <span [innerHtml]="(parentField.entity_names[innerIndex] ? parentField.entity_names[innerIndex] : 'survey_component.entity_name_label' | translate: { number: (innerIndex+1), name_of_questionnaire : (widgetConf | translation: 'title': lang) } | calioSafe: 'html')"></span>
  </div>
</ng-template>

<ng-template #entityNameFieldTemplate let-count let-widgetConf="widgetConf">
  <div class="mt-3 row" role="group" [attr.aria-label]="'Entity name fields for ' + (widgetConf | translation: 'title': lang)">
    @for (element of helperService.createArrayRange(count); track $index; let i = $index) {
      <div
        [class]="'border-end no-right-border-last-child border-sm-right-none mt-3 mt-md-0 mt-no-first-child col-md-'+ (12 / count)"
        role="group"
        [attr.aria-labelledby]="'entity_name_label_' + i"
      >
        <app-csw-text
          [customClass]="'csw-booking-question-title csw-booking-question-title-'+customField.id"
          [text]="'survey_component.entity_name_field_label' | translate: { number: (i+1), name_of_questionnaire : (widgetConf | translation: 'title': lang) } | calioSafe: 'html'"
          [styleConfig]="textContainerStyleConfig"
          [id]="'entity_name_label_' + i"
          role="heading"
          aria-level="3"
        />
        <input
          type="text"
          class="mt-1 form-control"
          [id]="'entity_name_' + i"
          [name]="'entity_name_' + i"
          #entity_name="ngModel"
          maxlength="300"
          [(ngModel)]="customField.entity_names[i]"
          [attr.aria-label]="'survey_component.entity_name_field_label' | translate: { number: (i+1), name_of_questionnaire : (widgetConf | translation: 'title': lang) }"
          [attr.aria-required]="true"
          [attr.aria-invalid]="entity_name.touched && entity_name.invalid"
          [attr.aria-describedby]="'entity_name_error_' + i"
          [attr.aria-disabled]="!isEditAllowed || deactivateField"
        />
        @if (entity_name.touched && entity_name.invalid) {
          <div
            class="text-danger"
            [id]="'entity_name_error_' + i"
            role="alert"
            aria-live="polite"
          >
            @if (entity_name.errors?.required) {
              {{ 'error_messages.required_error_message' | translate }}
            } @else if (entity_name.errors?.maxlength) {
              {{ 'error_messages.maximum_chars_error_message' | translate: { requiredLength: 300 } }}
            }
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #labelsTemplate>
  <div
    class="col-md-12"
    [ngStyle]="textContainerStyleConfig"
    role="group"
    [attr.aria-labelledby]="customField.id + '_label'"
    [attr.aria-describedby]="customField.id + '_description'"
  >
    @if (!((customField | translation: 'title': lang) | isEmptyString)) {
      <div role="group" [attr.aria-labelledby]="customField.id + '_title'">
        @if (prefix) {
          <app-csw-text
            [customClass]="'pe-2 csw-booking-question-title csw-booking-question-title-'+customField.id"
            [text]="prefix"
            [styleConfig]="titleStyleConfig"
            role="text"
            [attr.aria-label]="prefix"
          />
        }
        @if ((customField | translation: 'label': lang) && (customField.type !== customFieldConst.CUSTOM_FIELD_CHECKBOX)) {
          <div role="group" [attr.aria-labelledby]="customField.id + '_label'">
            <app-csw-text
              [customClass]="'csw-booking-question-title csw-booking-question-title-'+customField.id"
              [text]="(customField | translation: 'label': lang) | calioSafe: 'html'"
              [styleConfig]="titleStyleConfig"
              [id]="customField.id + '_label'"
              role="heading"
              aria-level="2"
            />
            @if (customField.required === 1) {
              <app-csw-text
                [customClass]="'csw-booking-question-title-required csw-booking-question-title csw-booking-question-title-'+customField.id"
                text=" *"
                [styleConfig]="titleStyleConfig"
                role="text"
                aria-hidden="true"
                [attr.aria-label]="'Required field'"
              />
            }
          </div>
        }
      </div>
    }

    @if ((customField | translation: 'title': lang) | isEmptyString) {
      <div role="group" [attr.aria-labelledby]="customField.id + '_title'">
        @if (prefix) {
          <app-csw-text
            [customClass]="'pe-2 csw-booking-question-title csw-booking-question-title-'+customField.id"
            [text]="prefix"
            [styleConfig]="titleStyleConfig"
            role="text"
            [attr.aria-label]="prefix"
          />
        }
        <app-csw-text
          [customClass]="'csw-booking-question-title csw-booking-question-title-'+customField.id"
          [text]="(customField | translation: 'title': lang) | calioSafe: 'html'"
          [styleConfig]="titleStyleConfig"
          [id]="customField.id + '_title'"
          role="heading"
          aria-level="2"
        />
      </div>
      @if ((customField | translation: 'label': lang) && (customField.type !== customFieldConst.CUSTOM_FIELD_CHECKBOX)) {
        <div role="group" [attr.aria-labelledby]="customField.id + '_label'">
          <app-csw-text
            [customClass]="'label csw-booking-question-title csw-booking-question-title-'+customField.id"
            [text]="(customField | translation: 'label': lang) | calioSafe: 'html'"
            [styleConfig]="labelStyleConfig"
            [id]="customField.id + '_label'"
            role="heading"
            aria-level="3"
          />
          @if (customField.required === 1) {
            <app-csw-text
              [customClass]="'label csw-booking-question-title-required csw-booking-question-title csw-booking-question-title-'+customField.id"
              text=" *"
              [styleConfig]="labelStyleConfig"
              role="text"
              aria-hidden="true"
              [attr.aria-label]="'Required field'"
            />
          }
        </div>
      }
    }
    @if ((customField | translation: 'description': lang) | isEmptyString) {
      <div
        [id]="customField.id + '_description'"
        role="note"
        class="mt-1"
      >
        <app-csw-text
          [customClass]="'csw-booking-question-description csw-booking-question-description-'+customField.id"
          [text]="(customField | translation: 'description': lang) | calioSafe: 'html'"
          [styleConfig]="descriptionStyleConfig"
        />
      </div>
    }
  </div>
</ng-template>

<!-- options dependent questions -->
<ng-content />
<!-- options dependent questions -->

<ng-template #endOfProcessBlock let-customClass="customClass">
  <div
    role="alert"
    class="alert alert-warning csw-end-of-process-block"
    [ngClass]="customClass ? customClass : null"
    [ngStyle]="textContainerStyleConfig"
    [attr.aria-label]="'End of process notification'"
    [attr.aria-live]="'polite'"
    [id]="customField.id + '_end_of_process'"
  >
    @if ((endOfProcessMessageObj | translation: 'end_of_process_message' : lang)?.trim()) {
      <div
        class="csw-end-of-process-text"
        role="status"
        [attr.aria-label]="'End of process message'"
        [innerHtml]="endOfProcessMessageObj | translation: 'end_of_process_message' : lang | calioSafe: 'html'"
      ></div>
    } @else {
      <div
        class="csw-end-of-process-text"
        role="status"
        [attr.aria-label]="'End of process message'"
        aria-hidden="true"
      >
        <!-- Empty state for screen readers -->
        <span class="visually-hidden">No end of process message available</span>
      </div>
    }
  </div>
</ng-template>
